import React, { useContext, useState, useEffect, useRef } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { Table, Input, Button, Form, message } from "antd";
const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      let values = await form.validateFields();
      if (dataIndex.toLowerCase() === "name") {
        values[dataIndex] = values[dataIndex].trim();
      }
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      // console.log("Save failed:", errInfo);
      message.error("une erreur a été détecté lors de l'insertion des données");
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `La ${
              title.toLowerCase() === "key" ? "clé" : "valeur"
            } est obligatoire.`,
          },
          {
            whitespace: true,
            message: `La ${
              title.toLowerCase() === "key" ? "clé" : "valeur"
            } est obligatoire.`,
          },
        ]}
      >
        <Input
          ref={inputRef}
          onPressEnter={save}
          placeholder={`Entrer la ${
            title.toLowerCase() === "key" ? "clé" : "valeur"
          }`}
          onBlur={save}
        />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
          color: children[1] ? "initial" : "#00000060",
        }}
        onClick={toggleEdit}
      >
        {children[1]
          ? children
          : [
              undefined,
              `Entrer la ${title.toLowerCase() === "key" ? "clé" : "valeur"}`,
            ]}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
const TableEditable = ({ updateData, type, data }) => {
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };
  const columns = [
    {
      title: "KEY",
      dataIndex: "name",
      width: "30%",
      editable: true,
      fixed: "left",
    },
    {
      title: "VALUE",
      dataIndex: "value",
      width: "60%",
      // maxWidth: "300px",
      editable: true,
    },
    {
      title: "",
      dataIndex: "sup",
      width: "10%",
      editable: false,
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Button
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.key)}
          />
        ) : null,
    },
  ];

  const [dataSource, setDataSource] = useState([
    {
      key: 0,
      name: "",
      value: "",
    },
  ]);
  const [count, setCount] = useState(0);
  // {
  //       key: 0,
  //       name: "Pas de données",
  //       value: "Pas de données",
  //     },
  useEffect(() => {
    setCount(dataSource.length + 1);
    const tab = dataSource.map(({ name, value }) => ({
      name: name,
      value: value,
    }));
    const newTab = data.map(({ categorie, donnees, selected }) => {
      if (categorie === type) {
        donnees = tab;
      }
      if (categorie === "RAW") {
        return { categorie, donnees, selected, type: "JSON" };
      } else {
        return { categorie, donnees, selected };
      }
    });
    updateData(newTab);

    // eslint-disable-next-line
  }, [dataSource]);
  const addItem = () => {
    const newparam = {
      key: count,
      name: "",
      value: "",
    };

    const newData = [...dataSource, newparam];
    setDataSource(newData);
  };

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const Ncolumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
      }),
    };
  });
  return (
    <div>
      <Table
        scroll={{ x: 200 }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={dataSource}
        columns={Ncolumns}
        pagination={false}
        locale={{ emptyText: "Aucune donnée" }}
      />
      <div style={{ textAlign: "right", marginTop: "5px" }}>
        <Button onClick={addItem}>Ajouter</Button>
      </div>
    </div>
  );
};
export default TableEditable;
